import "assets/css/charts_form_controls.css";
import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import axios from "axios";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import "assets/css/grid_table.css";
import moment from "moment";
import numeral from "numeral";
import { getDataApi, saveApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";

const NoPollDataDays = () => {
  let emptyRow = {
    file_id: null,
    file_name: "",
    file_date: "",
    num_of_data_rows: "",
    num_of_data_columns: "",
    num_of_nonzero_data: "",
    ora_machine_id: "",
    machine_name: "",
    dxp_file_prefix: "",
    process_id: "",
    process_name: "",
    production_line_number: "",
    ora_processed_flag: "",
    ora_error_message: "",
    local_file_size_bytes: "",
    local_file_delete_date: "",
    conc_request_id: "",
    remote_ip_address: "",
    remote_user_name: "",
    remote_dir_name: "",
    orig_ftpin_date: "",
    last_ftpin_date: "",
    remote_file_size_bytes: "",
    creation_date: "",
    last_update_date: ""
  };
  
  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loadingErrors, setLoadingErrors] = useState([]);
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] = useState(true);
  const [fileName, setFileName] = useState("");
  const [dateOption, setDateOption] = useState(null);
  const [machineName, setMachineName] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const toast = useRef(null);
  const dt = useRef(null);
  const initialLoadTriggeredRef = useRef(false);

  useEffect(() => {
    if (initialLoadTriggeredRef.current) {
      return;
    }

    initialLoadTriggeredRef.current = true;

    const fetchData = async () => {
      const pollDataDateTo = moment().subtract(1, "days").endOf("day");
      const pollDataDateFrom = moment(pollDataDateTo).subtract(10, "days").startOf("day");

      const formattedStartDate = pollDataDateFrom.format("yyyy-MM-DD HH:mm");
      const formattedEndDate = pollDataDateTo.format("yyyy-MM-DD HH:mm");

      setStartDate(formattedStartDate);
      setEndDate(formattedEndDate);
      await handleLoadData(formattedStartDate, formattedEndDate, false);
    };

    fetchData();
  }, []);

  const handleLoadData = async (overrideStartDate = startDate, overrideEndDate = endDate, showSuccessToast = true) => {

    const p_param = {
      p_start_datetime: overrideStartDate,
      p_end_datetime: overrideEndDate,
      p_file_name: fileName,
      p_machine_name_like: machineName,
      p_date_option: dateOption,
    };
    console.log(p_param);
    try {
      setIsLoading(true);
      const response = await loadApi(p_param, "api/txn/getNoPollDataDays");
      console.log("Fetched Data:", response.data);
      console.log(response.data[0]);
      console.log(response.data[1]);
      if (response.data.length > 0) {
        let successFlag = response.data[0];
        if (successFlag === "Y") {
          if (showSuccessToast) {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            });
          }
          console.log("success=Y");
          setRows(response.data[1]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(false);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
          const errorInfo = response.data[2];
          // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }
        //setSearch(response.data);
      } else {
        //setRows(null);
        setRows([]);
        setIsLoading(false);
        setWasDataFetchingSuccessful(true);
      }

      //setRows(response.data);
    } catch (error) { 
      if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
      } else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const hideDialog = () => {
    setRowDialog(false);
    setShowProductDialog(false);
    setErrorDialogVisible(false);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="row d-flex justify-content-center m-5">
          <div className="col-auto">
            <div className="card shadow-sm border-primary">
              <div className="card-header bg-primary text-white">
                <h2 className="mb-0">DXP Poll Data Files</h2>
              </div>
              <div className="card-body text-center">
                <h3>
                  <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                  The page is loading...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  const getLoadedHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="header-container">
        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
         PDCS Machines - No Poll Data Days
              {/* <div className="header-container p-1">
              <style>
              {`
                input::placeholder {
                  font-size: 17px;
                }
              `}
            </style>
          <span className="p-input-icon-right w-full md:w-auto"> 
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto text-sm p-3"
          style={{ fontSize: '17px' }} 
        />
      </span>
          </div> */}
          </h2>
        </div>
      </React.Fragment>
    );
  };
  const getErrrorMsgContents = () => {
    return (
      <React.Fragment>
        <div class="row mt-5 justify-content-md-center">
          <div class="col-3">
            <div class="card border-secondary">
              <div class="card-header bg-dark text-white">
                 No Poll Data Days table is Unavailable
              </div>
              <div class="card-body card-body-error rounded-bottom">
                <ul>
                  {loadingErrors.map((error) => (
                    <li>error</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  const getSearchControls = () => (
    <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Search</label>
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          disabled={isLoading}
          className="input-outline"
        />
      </div>
    </React.Fragment>
  );

  // const getFileNameControl = () => (
  //   <React.Fragment>
  //     <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
  //       <label className="form-label">File Name</label>
  //       <InputText
  //         type="text"
  //         id="FileName"
  //         name="FileName"
  //         onChange={(e) => setFileName(e.target.value)}
  //         placeholder="Enter file name"
  //         disabled={isLoading}
  //         className="input-outline"
  //       />
  //     </div>
  //   </React.Fragment>
  // );
  const getMachineNameControl = () => (
    <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Machine Name</label>
        <InputText
          type="text"
          id="MacName"
          name="MacName"
          onChange={(e) => setMachineName(e.target.value)}
          placeholder="Enter machine name"
          disabled={isLoading}
          className="input-outline"
        />
      </div>
    </React.Fragment>
  );

  const getStartEndDateControls = () => (
    <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Poll Data Date From</label>
        <div className="input-group date input-wrapper">
        <input
          type="datetime-local"
          id="StartDateTime"
          name="StartDateTime"
          value={startDate}
          onChange={handleStartDateChange}
          disabled={isLoading}
          className="input-outline1"
        />
        </div>
      </div>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Poll Data Date To</label>
        <div className="input-group date input-wrapper">
        <input
          type="datetime-local"
          id="EndDateTime"
          name="EndDateTime"
          value={endDate}
          onChange={handleEndDateChange}
          disabled={isLoading}
          className="input-outline1"
        />
        </div>
      </div>
    </React.Fragment>
  );

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const getGoButtonControl = () => (
    <React.Fragment>
      <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0" style={{paddingTop:'1.9375rem'}}>
        <button
          type="button"
          className="btn btn-primary load-button"
          id={"chartAreaId"}
          onClick={() => handleLoadData(startDate, endDate, true)}
          disabled={isLoading}
        >
           <i
            className={
              isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
            }
          ></i>
          <span>{isLoading ? "Loading" : "Go"}</span>
        </button>
      </div>
    </React.Fragment>
  );

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );
  const calendarDateTemplate = (rowData) => {
     return rowData.calendar_date ? moment.utc(rowData.calendar_date).format("YYYY-MM-DD HH:mm:ss") : null;
  };
 

  const fileDate = row.file_date ? moment.utc(row.file_date).format("YYYY-MM-DD HH:mm:ss") : null;
  const localFileDeleteDate = row.local_file_delete_date ? moment.utc(row.local_file_delete_date).format("YYYY-MM-DD HH:mm:ss") : null;
  const origFTPinDate = row.orig_ftpin_date ? moment.utc(row.orig_ftpin_date).format("YYYY-MM-DD HH:mm:ss") : null;
  const lastFTPinDate = row.last_ftpin_date ? moment.utc(row.last_ftpin_date).format("YYYY-MM-DD HH:mm:ss") : null;
  const creationDate = row.creation_date ? moment.utc(row.creation_date).format("YYYY-MM-DD HH:mm:ss") : null;
  const lastUpdateDate = row.last_update_date ? moment.utc(row.last_update_date).format("YYYY-MM-DD HH:mm:ss") : null;

  const rownumOfDataRowsNumber = numeral(row.num_of_data_rows).format("0,0");
  const numOfDataColumnsNumber = numeral(row.num_of_data_columns).format("0,0");
  const numOfNonZeroDataNumber = numeral(row.num_of_nonzero_data).format("0,0");
  const numOfProdLineNoNumber = numeral(row.production_line_number).format("0,0");
  const numOfLocalFileSizeNumber = numeral(row.local_file_size_bytes).format("0,0");
  const numFtpIdNumber = numeral(row.remote_ip_address).format("0,0");
  const numofRemoteFileSizeNumber = numeral(row.remote_file_size_bytes).format("0,0");

  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

   const CardComponent = ({title, data}) => {
      const rightAlignedLabels = ["File Id : ", "#Of Data Rows : ", "#Of Columns : ", "#Of Non-zero data : ", "Ln# : ",
        "Local File Size (B) : ", "Conc Req Id : ", "FTP IP : ", "Remote File Size (B) : "
      ]

      return (
        <Card className="card-containers">
          <h5  style={{"fontWeight":"bold"}}> {title} </h5>
          <Divider className="my-2" />
          {data.map((item, index) => (
            <div key={index} className="label-value-pair">
              <span className="label">{item.label}</span>
              
              {item.label &&
              <span         
              className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
                {item.value}</span>
              }
              
            </div>
          ))}
        </Card>
      )
    }

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
        {getLoadedHeaderContents()}
        <div className="row">
          <div className="col">
            <div className="row justify-content-center">
              {getSearchControls()}
              {getStartEndDateControls()}
              {/* {getFileNameControl()} */}
              {getMachineNameControl()}
              {getGoButtonControl()}
            </div>
            {!wasDataFetchingSuccessful && (
              <div className="card my-3">
                {/* <div className="text-3xl text-800 font-bold mb-4">DXP Poll Data Files</div> */}
                <DataTable
                  ref={dt}
                  value={rows}
                  scrollable
                  scrollHeight="flex"
                  selection={selectedRows}
                  onSelectionChange={(e) => setSelectedRows(e.value)}
                  dataKey="file_id"
                  className="custom-datatable-border"
                  tableStyle={{ minWidth: "50rem" }}
                  paginator
                  rows={pecaPageRows}
                  rowsPerPageOptions={pecaRowsPerPageOptions}
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
                  globalFilter={globalFilter}
                  header={header}
                  emptyMessage="No data found"
                  stripedRows
                  showGridlines
                >
                  {/* <Column
                    body={readBodyTemplate}
                    exportable={false}
                    style={{ width: "0.75rem" }}
                  ></Column> */}
                  <Column
                    field="calendar_date"
                    header="Calendar Date"
                    sortable
                    body={calendarDateTemplate}
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="machine_name"
                    header="Machine Name"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="dxp_file_prefix"
                    header="File Prefix"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  
                </DataTable>
              </div>
            )}
          </div>
        </div>
       <Dialog visible={showproductDialog} style={{ width: '1400px' }} modal className="p-fluid" onHide={hideDialog}>     
                 <h4 style={{"fontWeight":"bold"}}> No Poll Data Days </h4>
                 <Divider className="my-4" />
                 <h5 style={{"fontWeight":"bold"}}> View No Poll Data Days </h5>
                 <Divider className="my-4" />
                 <div className="card-wrapper">
                   <CardComponent
                     title="File Info"
                     data={[
                       {label:"File Name : ", value: row.file_name },
                       {label:"File Id : ", value: row.file_id },
                       {label:"Date : ", value: fileDate },
                       {label:"#Of Data Rows : ", value: rownumOfDataRowsNumber },
                       {label:"#Of Columns : ", value: numOfDataColumnsNumber },
                       {label:"#Of Non-zero data : ", value: numOfNonZeroDataNumber },
                     ]}
                   />
                   <CardComponent
                     title="Machine Info"
                     data={[
                       {label:"Machine Name : ", value: row.machine_name },
                       {label:"File Prefix : ", value: row.dxp_file_prefix },
                       {label:"Process : ", value: row.process_name },
                       {label:"Ln# : ", value: numOfProdLineNoNumber },
                     ]}
                   />
                   <CardComponent
                     title="Oracle Interface Info"
                     data={[
                       {label:"Ora Processed ? : ", value: row.ora_processed_flag },
                       {label:"Ora Errors : ", value: row.ora_error_message },
                       {label:"Local File Size(B) : ", value: numOfLocalFileSizeNumber },
                       {label:"Local File Delete Date : ", value: localFileDeleteDate},
                       {label:"Conc Req Id : ", value: row.conc_request_id },
                       {label:"Creation Date : ", value: creationDate },
                       {label:"Last Update Date : ", value: lastUpdateDate },
                     ]}
                   />
                  <CardComponent
                     title="Remote Server Info"
                     data={[
                       {label:"FTP IP : ", value: numFtpIdNumber },
                       {label:"FTP User : ", value: row.remote_user_name },
                       {label:"Remote Dir : ", value: row.remote_dir_name },
                       {label:"Orig Ftp Date : ", value: origFTPinDate},
                       {label:"Last Ftp Date : ", value: lastFTPinDate },
                       {label:"Remote File Size (B) : ", value: numofRemoteFileSizeNumber },
                     ]}
                   />
                  </div>
             </Dialog>
             <Dialog 
                 header="API Error" 
                 visible={errorDialogVisible} 
                 style={{ width: '400px' }} 
                 onHide={hideDialog} 
                 footer={
                     <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                 }
             >    
              <p>
 
                     {errorMessage}
                 </p>
             </Dialog>
             <style jsx>{`
               .card-wrapper {
                 display: grid;
                 grid-template-columns: repeat(2,1fr);
                 gap: 10px;
                 padding: 5px;
               }
 
               .card-containers {
                 display: flex;
                 background-color: #f9f9f9;
                 flex-direction: column;
                 justify-content: flex-start;
                 border: 1px solid #ccc;
                 paddig: 10px;
                 box-shadow: 4px 4px 10px rgba(0,0,0,0.2);
                 height: auto;
                 width: 100%;
               }
 
               .label-value-pair {
                 display: flex;
                 flex-direction: row,
                 align-items: flex-start;
                 gap: 5px;
                 margin-bottom: 8px;
                 flex-wrap: wrap;
               }
 
               .label {
                 font-weight: bold;
                 white-space: nowrap;
               }
 
               .value-box {
                 background-color:rgb(235, 235, 235);
                 padding: 6px 10px;
                 border-radius: 4px;
                 display: block;
                 word-wrap: break-word;
                 overflow-wrap: break-word;
                 flex-grow: 1;
                 min-width: 0;
               }
 
               .align-right {
                 text-align: right;
                 background-color:rgb(235, 235, 235);
                 padding: 6px 10px;
                 border-radius: 4px;
                 display: block;
                 word-wrap: break-word;
                 overflow-wrap: break-word;
                 flex-grow: 1;
                 min-width: 0;
               }
             `}
             </style>
             </div>
    </div>
  );
};

export default NoPollDataDays;
;
